import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";
import principle07 from "./layouts/principle-07/principle";
import principle08 from "./layouts/principle-08/principle";
import principle09 from "./layouts/principle-09/principle";
import principle10 from "./layouts/principle-10/principle";
import principle11 from "./layouts/principle-11/principle";
import principle12 from "./layouts/principle-12/principle";
import principle13 from "./layouts/principle-13/principle";
import principle14 from "./layouts/principle-14/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";

const lesson: Lesson = {
  id: "56e5a500-34d7-4b24-9f72-b8c803c906cc",
  publicId: "22",
  name: "Measurement and evaluation of airborne and impact sound insulation",
  difficulty: 3,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [
    principle01,
    principle02,
    principle03,
    principle04,
    principle05,
    principle06,
    principle07,
    principle08,
    principle09,
    principle10,
    principle11,
    principle12,
    principle13,
    principle14,
    task01,
    task02,
    task03,
    task04,
    task05,
  ],
};

export default lesson;
